module.exports = __webpack_public_path__ + "img/huoke_icon11.b74223a1.png";